import { useLang } from "../../App";

export const Reviews = () => {
  const { t } = useLang();
  return (
    <section className="py-20 border-b border-[#1e293b]/60" data-testid="reviews-section">
      <div className="max-w-6xl mx-auto px-6">
        <div className="flex flex-col sm:flex-row items-baseline justify-between mb-8">
          <div>
            <span className="mono text-xs uppercase tracking-widest text-[#fbbf24]">{t("reviews.eyebrow")}</span>
            <h2 className="disp text-2xl sm:text-3xl font-bold text-white mt-1">{t("reviews.title")}</h2>
          </div>
          <span className="mono text-xs text-slate-400 mt-2 sm:mt-0">{t("reviews.note")}</span>
        </div>
        <div className="grid md:grid-cols-2 gap-6">
          {[
            { text: t("reviews.p1"), label: t("reviews.l1"), id: "review-card-1" },
            { text: t("reviews.p2"), label: t("reviews.l2"), id: "review-card-2" },
          ].map((r) => (
            <div key={r.id} data-testid={r.id} className="rounded-xl border border-slate-700 bg-slate-900/60 p-8 hover:border-[#fbbf24]/40 transition-colors">
              <div className="flex items-center gap-1 text-[#fbbf24] text-sm mb-4" aria-label="5 star rating">
                {"★★★★★"}
              </div>
              <p className="text-sm sm:text-base text-slate-200 leading-relaxed">&ldquo;{r.text}&rdquo;</p>
              <div className="flex items-center gap-3 mt-5">
                <div className="w-10 h-10 rounded-full bg-[#fbbf24]/15 border border-[#fbbf24]/40 flex items-center justify-center text-[#fbbf24] font-bold text-sm">
                  {r.label.charAt(0)}
                </div>
                <span className="mono text-xs text-slate-400">{r.label}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
